import { memo, useMemo, useRef } from 'react';
import { DetailNewsWrapper } from './style';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { selectDetailNews } from './selectors';
import { isServer, removeScripts } from '@utils/helper';
import LinkInOutApp from '@components/LinkInOutApp';
import { DETAIL_NEWS_OTHER } from './constants';
import useIsPc from '@utils/hooks/useIsPc';
import dynamic from 'next/dynamic';
import { selectTranslate } from '@containers/Home/selectors';

const TableOfContent = dynamic(() => import('./components/TableOfContent'), {
  ssr: false,
});

const DetailNews = memo(() => {
  const isPc = useIsPc();
  const otherNewsRef = useRef(null);

  const detailNews = useSelector(selectDetailNews);
  const translate = useSelector(selectTranslate);

  const urlShare = isServer ? '' : window.location.href;

  const onShareSocial = key => {
    let url = '';
    switch (key) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          urlShare,
        )}`;
        window.open(url, '_blank');
        break;
      case 'reddit':
        url = `https://www.reddit.com/submit?url=${encodeURIComponent(
          urlShare,
        )}`;
        window.open(url, '_blank');
        break;
      case 'twitter':
        url = `https://twitter.com/share?url=${encodeURIComponent(urlShare)}`;
        window.open(url, '_blank');
        break;
      case 'google':
        url = `https://plus.google.com/share?url=${encodeURIComponent(
          urlShare,
        )}`;
        window.open(url, '_blank');
        break;
      default:
        break;
    }
  };

  const listSuggestNewsFiltered = useMemo(
    () => detailNews?.suggestList || [],
    [detailNews],
  );
  return (
    <DetailNewsWrapper>
      <div className="dtNewsContent">
        <div className="--img">
          <img src={detailNews?.imageThumbnails?.thumb1920} alt="" />
        </div>
        <div className="container-fluid">
          <div className="--content">
            <div className="--title">{detailNews?.title}</div>
            <div
              className={`--timeCate ${
                detailNews?.title && detailNews?.newscategory?.name
                  ? 'after'
                  : ''
              } `}
            >
              {detailNews?.newscategory?.name && (
                <div className="--cate">{detailNews?.newscategory?.name}</div>
              )}
              <div className="--time">
                <i className="fa-regular fa-calendar" />
                {detailNews?.date}
              </div>
            </div>

            {isServer ? (
              <article
                dangerouslySetInnerHTML={{
                  __html: removeScripts(detailNews?.content) || '',
                }}
              />
            ) : (
              <TableOfContent
                detail={detailNews?.content}
                showTOC={detailNews?.showTOC}
              />
            )}
            <div className="--tags">
              {detailNews?.tags?.map((item, index) => (
                <div className="--item" key={index}>
                  #{item}
                </div>
              ))}
            </div>
            <div className="--backShare">
              <LinkInOutApp href="/" className="--back link textHover">
                <>
                  <i className="fa-regular fa-arrow-left-long" />
                  {translate ? translate[`SunParadiseLand.back`] : ''}
                </>
              </LinkInOutApp>
              <ul className="--share d-flex align-items-center ">
                <li> {translate ? translate[`SunParadiseLand.share`] : ''}:</li>
                <li onClick={() => onShareSocial('twitter')}>
                  <img src="/static/img/icon-tw.svg" />
                </li>
                <li onClick={() => onShareSocial('facebook')}>
                  <img src="/static/img/icon-fb.svg" />
                </li>
                <li onClick={() => onShareSocial('linkedin')}>
                  <img src="/static/img/icon-linked.svg" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {listSuggestNewsFiltered.length > 0 && (
        <div className="dtNewsOther">
          <div className="container-fluid">
            <div className="--content">
              <div className="titleFrame">Bài viết liên quan</div>
              <div className="slider">
                <div
                  className={`--listNews ${
                    listSuggestNewsFiltered.length > (isPc ? 3 : 1)
                      ? ''
                      : 'litle'
                  }`}
                >
                  {listSuggestNewsFiltered.length > (isPc ? 3 : 1) ? (
                    <Slider ref={otherNewsRef} {...DETAIL_NEWS_OTHER}>
                      {listSuggestNewsFiltered?.map((item, index) => (
                        <LinkInOutApp
                          href={`/tin-tuc/${item?.slug}`}
                          className="--item link"
                          key={index}
                        >
                          <>
                            <div className="--img imgHover1">
                              <img src={item?.imageThumbnails?.thumb1000} />
                            </div>
                            <div className="--txt">
                              <div className="--cate">
                                {detailNews?.newscategory?.name}
                              </div>
                              <div className="--name">
                                <>{item?.title}</>
                              </div>
                              <article
                                dangerouslySetInnerHTML={{
                                  __html:
                                    removeScripts(item.shortContent) || '',
                                }}
                              />
                              <div className="--time">
                                <i className="fa-regular fa-calendar" />
                                {item.date}
                              </div>
                            </div>
                          </>
                        </LinkInOutApp>
                      ))}
                    </Slider>
                  ) : (
                    <>
                      {listSuggestNewsFiltered?.map((item, index) => (
                        <LinkInOutApp
                          href={`/tin-tuc/${item?.slug}`}
                          className="--item link"
                          key={index}
                        >
                          <>
                            <div className="--img imgHover1">
                              <img src={item?.imageThumbnails?.thumb1000} />
                            </div>
                            <div className="--txt">
                              <div className="--cate">
                                {detailNews?.newscategory?.name}
                              </div>
                              <div className="--name">
                                <>{item?.title}</>
                              </div>
                              <article
                                dangerouslySetInnerHTML={{
                                  __html:
                                    removeScripts(item.shortContent) || '',
                                }}
                              />
                              <div className="--time">
                                <i className="fa-regular fa-calendar" />{' '}
                                {item.date}
                              </div>
                            </div>
                          </>
                        </LinkInOutApp>
                      ))}
                    </>
                  )}
                </div>
                {listSuggestNewsFiltered?.length > (isPc ? 3 : 1) && (
                  <div className="arrow">
                    <div
                      className="--arrow prev"
                      onClick={() => otherNewsRef?.current?.slickPrev()}
                    >
                      <i className=" fa-regular fa-chevron-left" />
                    </div>
                    <div
                      className="--arrow next"
                      onClick={() => otherNewsRef?.current?.slickNext()}
                    >
                      <i className=" fa-regular fa-chevron-right" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </DetailNewsWrapper>
  );
});
export default DetailNews;
